import * as React from "react";
import { Table, Icon } from "semantic-ui-react";

import { getMedicalTypeName } from "@teamprevent/common/customMedicalTypes/model";
import { getFeatureToggles } from "@teamprevent/common/getFeatureToggles";
import * as FeatureToggleNames from "@teamprevent/common/featureToggleNames";

import { MedicalOutcome, CustomMedicalType, DecisionPendingClarificationOptions } from "../models";

import { CertificateMedicalOutcomeModel } from "./models";

interface Props {
    model: CertificateMedicalOutcomeModel;
    customMedicalTypes: CustomMedicalType[] | undefined;
}

const getHSOutcomeIcon = (medicalOutcome: MedicalOutcome): React.JSX.Element => {
    switch (medicalOutcome) {
        case MedicalOutcome.fit:
        case MedicalOutcome.noIssue:
            return <Icon name="check circle" color="green" />;
        case MedicalOutcome.decisionPending:
        case MedicalOutcome.fitWithAdjustments:
            return <Icon name="check circle" color="orange" />;
        case MedicalOutcome.ohaToReview:
            return <Icon name="times circle" color="red" />;
        default:
            return <Icon name="check circle" color="red" />;
    }
};

const OutcomeDetails: React.FunctionComponent<Props> = (props) => {

    const medicalOutcome = MedicalOutcome[props.model.outcome];
    const decisionPendingClarificationText = props.model.outcome === "decisionPending" ?
        DecisionPendingClarificationOptions.find(o => o.value === props.model.decisionPendingClarification)?.text : "";
    const enableHealthSurveillanceCrs11_3 = getFeatureToggles()[FeatureToggleNames.EnableHealthSurveillanceCrs11_3];

    return (
        <Table>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell width="6">{getMedicalTypeName(props.customMedicalTypes, props.model.medicalTypeId)}</Table.HeaderCell>
                    <Table.HeaderCell width="6" />
                    <Table.HeaderCell width="4" />
                </Table.Row>
            </Table.Header>
            <Table.Body>
                <Table.Row>
                    <Table.Cell><strong>Outcome</strong></Table.Cell>
                    <Table.Cell>{medicalOutcome}</Table.Cell>
                    <Table.Cell>{getHSOutcomeIcon(medicalOutcome)}</Table.Cell>
                </Table.Row>
                <Table.Row>
                    <Table.Cell><strong>Date</strong></Table.Cell>
                    <Table.Cell>{props.model.dateCreated.format("Do MMMM YYYY")}</Table.Cell>
                    <Table.Cell />
                </Table.Row>
                <Table.Row>
                    <Table.Cell><strong>Comments</strong></Table.Cell>
                    <Table.Cell>
                        {enableHealthSurveillanceCrs11_3 && decisionPendingClarificationText && `${decisionPendingClarificationText} `}
                        {props.model.customerNotes}
                    </Table.Cell>
                    <Table.Cell />
                </Table.Row>
            </Table.Body>
        </Table>
    );
};

export { OutcomeDetails, getHSOutcomeIcon };
